module.exports = __webpack_public_path__ + "img/pin_logo_active.e5cd762.svg";